import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = {
    url: String
  }

  loadStudents() {
    const teacherId = this.selectTarget.value
    const frame = document.getElementById("eligible_students_frame")

    if (!teacherId) {
      if (frame) {
        frame.innerHTML = "<p class='mt-2 text-sm text-gray-500 italic'>No teacher selected.</p>"
      }
      return
    }

    // cache-bust so Turbo always treats it as a new request
    const url = `${this.urlValue}?teacher_id=${encodeURIComponent(teacherId)}&t=${Date.now()}`

    if (frame) {
      frame.src = url
    }
  }
}
